import { WidgetSizeT } from "../../localTypes/WidgetSizeT";

export function WAWidgetSizeToTaskSingleSize(size: WidgetSizeT) {
  switch (size.w) {
    case 1:
      return "ONE_X_ONE";
    case 2:
      return "TWO_X_ONE";
  }
}
